/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/success-mark-otg': {
    width: 110,
    height: 110,
    viewBox: '0 0 110 110',
    data: '<rect pid="0" x="1" y="1" width="108" height="108" rx="54" _fill="#37A48B"/><path pid="1" d="M39.183 55.826l10.328 10.327 22.306-22.305" _stroke="#fff" stroke-width="6"/><rect pid="2" x="1" y="1" width="108" height="108" rx="54" _stroke="#fff" stroke-width="2"/>'
  }
})
